import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { FieldFooter } from '../../atoms/field-footer';
import { Radio as RadioAtom } from '../../atoms/radio';
import { TextLabel } from '../../atoms/text-label';
import styles from './radio.module.scss';
/**
 * `RadioInput` is a flexible radio component that includes a customizable label and footer.
 * It provides a structured way to combine a radio with additional information.
 *
 * @property {string} [className] - Additional CSS classes for the wrapper element.
 * @property {ReactElement<typeof FieldFooter>} [footer] - An optional footer, e.g., for additional information.
 * @property {ReactElement<typeof TextLabel>} label - The label for the radio.
 *
 * @example
 * ```tsx
 * <Radio
 *   name="terms"
 *   onChange={handleRadioChange}
 *   label={<Radio.Label>Accept Terms & Conditions</Radio.Label>}
 *   footer={<Radio.Footer>More information</Radio.Footer>}
 * />
 * ```
 */ export const Radio = ({ className, errorMessage, footer, label, ...props })=>// biome-ignore lint/a11y/noLabelWithoutControl: input expected as child
    /*#__PURE__*/ _jsxs("label", {
        className: classNames(styles.wrapper, className),
        children: [
            /*#__PURE__*/ _jsx(RadioAtom, {
                ...props
            }),
            label,
            footer && /*#__PURE__*/ _jsx(FieldFooter, {
                className: styles.footer,
                "data-testid": "field-footer",
                children: footer
            }),
            errorMessage && /*#__PURE__*/ _jsx(FieldFooter, {
                className: styles.error,
                "data-testid": "field-error",
                error: true,
                children: errorMessage
            })
        ]
    });
Radio.Label = TextLabel;
Radio.Footer = FieldFooter;

//# sourceMappingURL=index.js.map